module.exports = {
  sanity: {
    projectId: process.env.SANITY_PROJECT_ID || '2unfttox',
    dataset: process.env.SANITY_DATASET || 'production',
  },
};
